// Home.js
import React, { useEffect, useState } from "react";
import Header from "./common/Header";
import Card from "./common/Card";
import apiCall from "./common/Utils/helper";
import Masonry from "react-masonry-css";
import SharePopup from "./Components/SharePopup";

const Home = () => {
  const [folderData, setFolderData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupId, setPopupId] = useState(null);
  const [popupFolderName, setPopupFolderName] = useState("");

  useEffect(() => {
    const fetchFolderData = async () => {
      try {
        const result = await apiCall(
          "get",
          "/getdistinctfolder?page=1&limit=50"
        );
        if (result.resultFlag === 1) {
          setFolderData(result.response.folderNames);
          // setIsFetching(true);
        } else {
          console.error("Failed to retrieve folder data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching folder data:", error);
      }
    };

    fetchFolderData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);

  const fetchNextPage = async () => {
    if (isFetching) return;
    setIsFetching(true);
    try {
      const nextPage = currentPage + 1;
      const result = await apiCall(
        "get",
        `/getdistinctfolder?page=${nextPage}&limit=50`
      );
      if (result.resultFlag === 1) {
        setFolderData((prevState) => [
          ...prevState,
          ...result.response.folderNames,
        ]);
        setCurrentPage(nextPage);
      } else {
        console.error("Failed to retrieve next page data:", result.message);
      }
    } catch (error) {
      console.error("Error fetching next page data:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 5 >
      document.documentElement.offsetHeight
    ) {
      if (!isFetching) {
        fetchNextPage();
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, isFetching]);

  const togglePopup = (id, folderName) => {
    setShowPopup(!showPopup);
    setPopupId(id);
    setPopupFolderName(folderName);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    600: 1,
  };

  return (
    <>
      {showPopup && (
        <SharePopup
          onClose={handleClosePopup}
          id={popupId}
          folderName={popupFolderName}
        />
      )}
      <Header />
      <div className="list_section">
        <div className="photonav_container">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {folderData.map((folderDataItem, index) => (
              <Card
                key={index}
                folderName={folderDataItem.folder_name}
                assetDate={folderDataItem.asset_date}
                folderPaths={folderDataItem.file_paths}
                folderId={folderDataItem.folder_id}
                togglePopup={togglePopup}
              />
            ))}
          </Masonry>
          {/* <button
            className="loadmore"
            onClick={() => {
              fetchNextPage();
            }}
          >
            Load More
          </button> */}
        </div>
      </div>
    </>
  );
};

export default Home;
